import React, { useContext, useEffect } from "react";
import axios from "axios";
import RegistrationContext from "../../contexts/RegistrationContext";
import { base_url } from "../../config";
import "./style.scss";
import {
  LayoutDashboard,
  UsersIcon,
  Plane,
  GraduationCapIcon,
  NotebookText,
  Barcode,
  MonitorCheck,
  Sheet,
  Camera,
  BadgeCheck,
  Ban,
} from "lucide-react";

function AdminMenu() {
  const { setError, screen, setScreen, reloadAdminBadges, permissions } =
    useContext(RegistrationContext);

  const [badges, setBadges] = React.useState({});

  const handler = async (step) => {
    if (step === screen) return;
    setError("");
    try {
      await axios.post(`${base_url}/api/jump`, { step });
      setScreen(step);
    } catch (error) {
      setError("Not accessible step");
    }
  };

  const getAdminBadges = async () => {
    try {
      const response = await axios.get(`${base_url}/api/admin/badges`);
      setBadges(response.data);
    } catch (error) {
      setError("Error fetching badges");
    }
  };

  useEffect(() => {
    getAdminBadges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadAdminBadges]);

  const Badge = ({ step }) => {
    const stepName = step.replace("admin-", "");
    const count = badges[stepName];
    if (!count) return null;
    return (
      <span className="admin-menu__badge">
        {count > 99 ? "99+" : count}
      </span>
    );
  };

  const menu = [
    {
      icon: <LayoutDashboard className="w-5 h-5" />,
      name: "Dashboard",
      value: "admin-dashboard",
    },
    {
      icon: <UsersIcon className="w-5 h-5" />,
      name: "Registrations",
      value: "admin-registrations",
    },
    {
      icon: <GraduationCapIcon className="w-5 h-5" />,
      name: "WS & Tut",
      value: "admin-workshops",
    },
  ];

  if (permissions.includes("ijcai_codes")) {
    menu.push({
      icon: <Barcode className="w-5 h-5" />,
      name: "Gift Codes",
      value: "admin-codes",
    });
  }
  if (permissions.includes("ijcai_students")) {
    menu.push({
      icon: <GraduationCapIcon className="w-5 h-5" />,
      name: "Students",
      value: "admin-student",
    });
    menu.push({
      icon: <BadgeCheck className="w-5 h-5" />,
      name: "EurAI",
      value: "admin-eurai",
    });
  }
  if (permissions.includes("ijcai_visa")) {
    menu.push({
      icon: <Plane className="w-5 h-5" />,
      name: "Visa",
      value: "admin-visa",
    });
  }
  if (permissions.includes("ijcai_cancellations")) {
    menu.push({
      icon: <Ban className="w-5 h-5" />,
      name: "Cancellations",
      value: "admin-cancellations",
    });
  }
  if (permissions.includes("ijcai_papers")) {
    menu.push({
      icon: <NotebookText className="w-5 h-5" />,
      name: "Papers",
      value: "admin-paper",
    });
  }
  if (permissions.includes("ijcai_exhibitors")) {
    menu.push({
      icon: <MonitorCheck className="w-5 h-5" />,
      name: "Exhibitors",
      value: "admin-exhibitors",
    });
  }
  menu.push({
    icon: <Camera className="w-5 h-5" />,
    name: "Press",
    value: "admin-press",
  });
  menu.push({
    icon: <Sheet className="w-5 h-5" />,
    name: "Exports",
    value: "admin-exports",
  });

  return (
    <nav className="admin-menu" aria-label="Admin sections">
      <div className="admin-menu__inner">
        {menu.map((step) => {
          const isActive = step.value === screen;
          return (
            <button
              key={step.value}
              type="button"
              onClick={() => handler(step.value)}
              aria-current={isActive ? "page" : undefined}
              className={`admin-menu__item ${
                isActive ? "admin-menu__item--active" : ""
              }`}
            >
              <span className="admin-menu__icon">
                {step.icon}
                <Badge step={step.value} />
              </span>
              <span className="admin-menu__label">{step.name}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default AdminMenu;
